import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import Panel from '@common/Panel'
import moment from 'moment'
import { Progress } from 'hljd'
import { Flex } from 'hljd'
import styles from './style.module.less'

@inject('pageStore')
@observer
export default class extends Component {
  getPackageList = list => {
    if (list && list.length > 0) {
      return list.map(item => {
        const { id, title, start_at, end_at } = item
        const end = moment(end_at)
        const leftDays = end.diff(moment(), 'days')
        const totalDays = end.diff(moment(start_at), 'days')
        const usedPercentage = (leftDays / totalDays) * 100

        return (
          <div key={id}>
            <div>{title}</div>

            <Flex>
              <Progress percent={usedPercentage} showInfo={false} />
              <span className={styles.days}>剩余{leftDays}天</span>
            </Flex>
          </div>
        )
      })
    }

    return (
      <Flex d="v" vc>
        <img
          src="//qnm.hunliji.com/FgEce7j6BQCkwDXFch__XNC6XGqM"
          style={{ width: 89 }}
        />

        <span style={{ marginTop: 10 }}>没有激活的套包哦～</span>
      </Flex>
    )
  }

  render() {
    const {
      pageData: { list }
    } = this.props.pageStore

    const packageList = this.getPackageList(list)

    return <Panel title="套包概览">{packageList}</Panel>
  }
}
